import React from "react"
import { Link } from "gatsby-interface"
import { SiteSettingsSection, SiteSettingsSectionLabel } from "../constants"
import SiteSettingsSectionCard from "./SiteSettingsSectionCard"
import {
  getBuildWebhookUrl,
  getPreviewWebhookUrl,
  getContentLoaderUrl,
} from "@modules/site/shared/helpers"
import { getSiteDetailsTabBasePath } from "@modules/site/details/utils"
import { SiteDetailsTab } from "@modules/site/details/constants"
import { WebhookItem } from "./WebhookItem"
import { WebhookHelpLink } from "./WebhookHelpLink"

const webhookWrapperCss = theme => ({
  display: `flex`,
  flexDirection: `column`,
  gap: theme.space[8],
})

const titleCss = theme => ({
  display: `flex`,
  alignItems: `center`,
  gap: theme.space[3],
})

const descriptionCss = theme => ({
  fontSize: theme.fontSizes[1],
  color: theme.colors.grey[90],
  marginTop: theme.space[3],
  marginBottom: theme.space[8],
})

export default function WebhookSection({
  siteId,
  organizationId,
  buildsEnabled,
}) {
  const previewWebhookUrl = getPreviewWebhookUrl(siteId)
  const buildsWebhookUrl = getBuildWebhookUrl(siteId)
  const contentLoaderURL = getContentLoaderUrl(siteId)
  const linkToDataSources = `${getSiteDetailsTabBasePath(
    SiteDetailsTab.Settings,
    siteId,
    organizationId
  )}/${SiteSettingsSection.DataSources}`

  return (
    <SiteSettingsSectionCard
      css={{ display: "block" }}
      id={SiteSettingsSection.Webhook}
      renderTitle={defaultTitle => (
        <div css={titleCss}>
          {defaultTitle}
          {` `}
          <WebhookHelpLink
            url="https://support.gatsbyjs.com/hc/en-us/articles/17278044618260-Build-and-Preview-Webhooks"
            aria-label="Webhook docs"
          />
        </div>
      )}
    >
      <div css={descriptionCss}>
        <Link to={linkToDataSources}>Connect a data source</Link>
        {` `}
        or use the webhook URLs below:
      </div>
      <div css={webhookWrapperCss}>
        <WebhookItem
          title={SiteSettingsSectionLabel[SiteSettingsSection.PreviewWebhook]}
          url={previewWebhookUrl}
          type={SiteSettingsSection.PreviewWebhook}
        />
        {buildsEnabled && (
          <WebhookItem
            title={SiteSettingsSectionLabel[SiteSettingsSection.BuildsWebhook]}
            url={buildsWebhookUrl}
            type={SiteSettingsSection.BuildsWebhook}
          />
        )}
        <WebhookItem
          title={SiteSettingsSectionLabel[SiteSettingsSection.ContentLoader]}
          url={contentLoaderURL}
          type={SiteSettingsSection.ContentLoader}
          infoLinkUrl="https://www.gatsbyjs.com/docs/conceptual/content-sync"
        />
      </div>
    </SiteSettingsSectionCard>
  )
}
